export const Title = ({ children }: { children: string | React.ReactNode }) => (
  <h2 className='mc-text-h2' style={{ fontSize: 32 }}>
    {children}
  </h2>
)
